import { DisposalRecordFloorUnit } from '@agency/apis/disposals';
import { t } from '@core/i18n';
import { sqftToValue, valueToSqFt } from '@shared/utils/number';

import { RecordSpaceItemError } from './RecordSpacesTakenForm';

export const calculateTotalSize = (
  floorUnits: DisposalRecordFloorUnit[],
  totalSizeMetric: Metric,
  disposalSizeFrom: number,
  disposalSizeTo: number
): number => {
  let totalSizeSqft = 0;

  if (floorUnits.length) {
    floorUnits.forEach(function (item) {
      // Recalculate sqft value
      item.size_value_sqft = valueToSqFt(Number(item.size_value) ?? 0, item.size_metric);

      // Append size if we have a positive value
      if (item.size_value_sqft) {
        totalSizeSqft += item.size_value_sqft;
      }
    });
  } else if (disposalSizeFrom || disposalSizeTo) {
    return Math.round(sqftToValue(Math.max(disposalSizeFrom, disposalSizeTo), totalSizeMetric) * 100) / 100;
  }

  // Calculate the total in the requested metric
  if (totalSizeMetric) {
    return Math.round(sqftToValue(totalSizeSqft, totalSizeMetric) * 100) / 100;
  }

  return 0;
};

const validateSpace = (space: DisposalRecordFloorUnit): { errors: RecordSpaceItemError; hasErrors: boolean } => {
  const errors: RecordSpaceItemError = {
    floor: '',
    description: '',
    size: '',
  };

  let hasErrors = false;

  if (space.floor === null || space.floor === '') {
    errors.floor = t('xtextx_is_required', { text: 'floor_or_level' });
    hasErrors = true;
  }

  if (!space.id && space.part_floor && !space.unit_string) {
    errors.description = t('xtextx_is_required', { text: 'description' });
    hasErrors = true;
  }

  if (!space.size_value) {
    errors.size = t('xtextx_is_required', { text: 'size' });
    hasErrors = true;
  } else if (!space.size_metric) {
    errors.size = t('xtextx_is_required', { text: 'size_metric' });
    hasErrors = true;
  }

  return {
    errors: errors,
    hasErrors: hasErrors,
  };
};

export const validateSpaces = (
  spaces: DisposalRecordFloorUnit[]
): { errors: Record<number, RecordSpaceItemError>; hasErrors: boolean } => {
  const errors: Record<number, RecordSpaceItemError> = {};
  let hasErrors = false;

  spaces.forEach((space, idx) => {
    if (!space.include) {
      return;
    }

    const spaceErrors = validateSpace(space);
    if (Object.keys(spaceErrors).length) {
      errors[idx] = spaceErrors.errors;
      hasErrors = spaceErrors.hasErrors;
    }
  });

  return {
    errors: errors,
    hasErrors: hasErrors,
  };
};
